// Copyright © 2026 Spicy Friends

import { createFileRoute, redirect } from '@tanstack/react-router'
import FeedMain from '@web/src/features/feed/feed-main'
import FinishProfilePrompt from '@web/src/features/feed/finish-profile-prompt/finish-profile-prompt'
import { authQueryKeys } from '@web/src/hooks/use-auth'
import type { BetterAuthSessionData } from '@web/src/lib/yoga/yoga-auth-context'
import { z } from 'zod'
import { feedPageHeadFromLoaderData } from './feed.seo'

const feedSearchSchema = z.object({
  sortBy: z.enum(['LATEST', 'FEED']).optional(),
})

export const Route = createFileRoute('/(auth)/(main-layout)/feed')({
  staticData: {
    canonicalPathname: '/feed',
  },
  component: FeedPage,
  head: () => feedPageHeadFromLoaderData(),
  validateSearch: feedSearchSchema,
  loader: ({ context }) => {
    const session = context.queryClient.getQueryData(authQueryKeys.session) as BetterAuthSessionData | undefined
    if (!session?.session) {
      throw redirect({ to: '/' })
    }
  },
})

function FeedPage() {
  return (
    <>
      <FinishProfilePrompt />
      <div className="mx-auto w-full max-w-7xl px-2">
        <FeedMain />
      </div>
    </>
  )
}
